import { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router";

import { Preloader } from "../components";
import { NotFound } from "../pages/authPages";
import { SiteWithPermsDto } from "../types/blastDtos";
import { isBlast } from "../utils";
import { RouteContext } from "./routeContext";
import { UserDataContext } from "./userDataContext";

const emptySite = {
	id: "",
	name: "",
	subscriptionId: "",
	subscriptionSubscriberOrgId: "",
	permissions: isBlast
		? {
				isSubManager: false,
				isSiteAdmin: false,
				isSiteUser: false,
		  }
		: {},
} as SiteWithPermsDto;

export const SiteContext = createContext({
	selectedSite: emptySite,
});

export const SiteContextProvider = ({ children }: { children: any }) => {
	const { selectedOrg, userOrgs, setNewSelectedOrg } =
		useContext(UserDataContext);
	const { route } = useContext(RouteContext);

	const { siteId } = useParams<{ siteId: string }>();
	const [{ isRightOrg, hasOrg }, setOrgStatus] = useState<{
		isRightOrg: boolean | null;
		hasOrg: boolean | null;
	}>({
		isRightOrg: false,
		hasOrg: true,
	});
	const [trigger, setTrigger] = useState(false);
	const [selectedSite, setSelectedSite] = useState({
		...emptySite,
		id: siteId,
	});

	const findSite = () => {
		if (selectedOrg.sites) {
			const site = selectedOrg.sites.find(({ id }) => id === siteId);
			if (!!site) {
				setSelectedSite(site);
				console.log("setSelectedSite");
				return { hasOrg: true, isRightOrg: true };
			}
		}

		for (var org of userOrgs) {
			if (org.sites) {
				const site = org.sites.find(({ id }) => id === siteId);

				if (!!site) {
					console.error("bad org");
					setNewSelectedOrg(org);
					setTrigger((t) => !t);
					return { hasOrg: true, isRightOrg: false };
				}
			}
		}
		setSelectedSite({ ...emptySite });

		return { hasOrg: false, isRightOrg: false };
	};

	useEffect(() => {
		if (siteId?.length) {
			setOrgStatus(findSite());
		}
	}, [trigger, siteId]);

	if (isRightOrg || !route.isSitePage || import.meta.env.MODE === "test")
		return (
			<SiteContext.Provider value={{ selectedSite }}>
				{children}
			</SiteContext.Provider>
		);

	if (hasOrg) return <Preloader />;

	console.log("not found");

	return <NotFound />;
};
